module.exports = __webpack_public_path__ + "img/default-cover.b854e90f.png";